import { normalizeSummaryRow } from './renderSummary';

export function normalizeSummaryConfig(config = {}) {
    const rows = Array.isArray(config.rows) ? config.rows.map(normalizeSummaryRow) : [];
    const maxRowCells = rows.reduce((max, row) => Math.max(max, row.cells.length), 0);
    const configuredColumns = Number.isFinite(config.valueColumns) ? Number(config.valueColumns) : 0;

    return {
        scope: config.scope || 'filtered',
        className: config.className || '',
        variant: config.variant || 'default',
        emptyText: config.emptyText || '',
        gap: config.gap ?? '16px',
        valueColumns: Math.max(1, configuredColumns || maxRowCells || 1),
        rows
    };
}
